var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions"},[(_vm.canDelete)?_c('a',{staticClass:"btn btn-third btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.deleting.apply(null, arguments)}}},[_c('i',{staticClass:"icofont icofont-close"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }